// eslint-disable-next-line no-multi-assign
window.jQuery = window.$ = require('jquery');
window.DOMPurify = require('dompurify');
var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('./components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/externalLinksModal'));
    processInclude(require('./components/subscriptionAddressModal'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/toolTip'));
    processInclude(require('./components/customInputs'));
    processInclude(require('./account/guestOrderStatus'));
    processInclude(require('./components/discountPrice'));
    processInclude(require('./accesibilityErrorHandler'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
